import React from "react";
import { Link } from "react-router-dom";
import logoWordmark from "../assets/kronaly-dark.png";

/**
 * Layout central para pantallas de autenticación. Centra una tarjeta DS
 * sobre `--kr-bg-app` con el logo Kronaly arriba y un footer minimal.
 */
export function AuthShell({ children, footer, width = 420 }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "var(--kr-bg-app)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px 16px",
      }}
    >
      <Link to="/" style={{ marginBottom: 24, textDecoration: "none" }}>
        <img src={logoWordmark} alt="Kronaly" style={{ height: 22 }} />
      </Link>
      <div
        style={{
          width: "100%",
          maxWidth: width,
          background: "var(--kr-bg-surface)",
          border: "1px solid var(--kr-border)",
          borderRadius: "var(--kr-radius-lg)",
          boxShadow: "var(--kr-shadow-md)",
          padding: 32,
        }}
      >
        {children}
      </div>
      {footer && (
        <div
          style={{
            marginTop: 20,
            textAlign: "center",
            fontSize: 12,
            color: "var(--kr-fg-muted)",
            maxWidth: width,
          }}
        >
          {footer}
        </div>
      )}
      <div
        style={{
          marginTop: 24,
          fontSize: 11,
          color: "var(--kr-fg-subtle)",
        }}
      >
        © {new Date().getFullYear()} Kronaly
      </div>
    </div>
  );
}

export default AuthShell;
